<script>
import { iFeaturedIcon, iFeaturedIconSizes } from '@inscribe/signal';

export default {
  components: { iFeaturedIcon },
  props: {
    riskLevel: {
      type: String,
      required: true,
    },
    confidence: {
      type: String,
      required: true,
    },
  },
  data() {
    return { iFeaturedIconSizes, hovering: false };
  },
  computed: {
    featuredIconProperties() {
      const properties = {
        symbol: '',
        type: '',
      };

      switch (this.riskLevel) {
        case 'LOW':
          properties.symbol = 'small-check-1';
          properties.type = 'success';
          break;
        case 'MEDIUM':
          properties.symbol = 'small-alert-circle';
          properties.type = 'warning';
          break;
        case 'HIGH':
          properties.symbol = 'small-alert-triangle';
          properties.type = 'error';
          break;
      }

      return properties;
    },
    formattedRiskLevel() {
      return (
        this.riskLevel.charAt(0).toUpperCase() +
        this.riskLevel.slice(1).toLowerCase() +
        ' Risk'
      );
    },
    formattedConfidence() {
      return 'Confidence level ' + this.confidence.toLowerCase();
    },
  },
};
</script>

<template>
  <div
    class="report-risk-header d-flex layout-row align-items-center i-radius-xl i-px-8 i-py-8"
  >
    <div class="content d-flex layout-row align-items-center">
      <i-featured-icon v-bind="featuredIconProperties"></i-featured-icon>
      <div class="text d-flex flex-column align-items-start">
        <div class="i-text-button-3 i-text-neutral-120">
          {{ formattedRiskLevel }}
        </div>
        <div class="i-text-body-3 i-text-neutral-110">
          {{ formattedConfidence }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.report-risk-header {
  width: 100%;
  height: 68px;
  border: 1px solid $light-neutral-60;
  background: $light-neutral-default;
  box-sizing: border-box;

  .content {
    gap: 12px;
    width: 100%;

    .text {
      flex: 1;
    }
  }
}
</style>
